import React from 'react';

// Animated brand mark for loading states — the stem draws upward from the
// seed, leaves sprout, hold, fall away, the stem retracts, then it loops.
// Mirrors public/favicon.svg's exact paths/colors so it reads as "the logo
// growing," not a generic spinner. Animation itself lives in index.css
// (@keyframes can't be expressed as inline style objects, the pattern this
// app otherwise uses everywhere).
export default function LoadingLeaf({ size = 64, label, fullScreen = false }) {
  const icon = (
    <svg width={size} height={size} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="512" height="512" rx="112" fill="var(--forest)" />
      <path
        className="loading-leaf-stem"
        d="M256 396 C 256 320, 256 250, 256 156"
        stroke="var(--cream)" strokeWidth="34" strokeLinecap="round" fill="none"
      />
      <path
        className="loading-leaf-left"
        d="M252 312 C 184 312, 132 262, 124 192 C 196 196, 248 244, 252 312 Z"
        fill="var(--sage)"
      />
      <path
        className="loading-leaf-right"
        d="M260 252 C 330 252, 384 198, 392 124 C 318 128, 264 180, 260 252 Z"
        fill="var(--gold)"
      />
      <circle cx="256" cy="400" r="26" fill="var(--gold)" />
    </svg>
  );

  const content = (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '14px' }}>
      {icon}
      {label && (
        <div style={{ fontSize: '13px', color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}>
          {label}
        </div>
      )}
    </div>
  );

  if (!fullScreen) return content;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      {content}
    </div>
  );
}
